import styled, { useTheme } from 'styled-components';
import {
  Heading1Text,
  Heading2Text,
  Heading3Text,
  ParagraphLargeText,
  TitleMedium,
} from '../../../../components/Texts';
import Line from '../../../../components/Line';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import WidthContainer from '../../../../components/WidthContainer';
import ColorizedSpan from '../../../../components/Colorized';
import { selectThemeMode } from '../../../../redux/slices/themeSlice';
import { useSelector } from 'react-redux';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 25px;
  margin-bottom: 20px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  padding-bottom: 50px;
  @media ${PHONE_MEDIA_QUERY} {
    padding-top: 25px;
    padding-bottom: 25px;
    flex-direction: column;
    width: 95%;
  }
`;

const SecondContainer = styled(InnerContainer)``;

const StyledParagraphLargeText = styled(ParagraphLargeText)`
  font-weight: 400;
`;

const Image = styled.img`
  width: 450px;
  @media ${PHONE_MEDIA_QUERY} {
    width: 90%;
  }
`;

const HowItWorks = () => {
  const theme = useTheme();
  const themeMode = useSelector(selectThemeMode);
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const [searchParams] = useSearchParams();
  const lpd = searchParams.get('lpd');
  const isPayments = lpd === 'payments';
  const isYield = lpd === 'yield';

  const getHeading = () => {
    if (isPayments) return <>Get paid in <ColorizedSpan>3 steps</ColorizedSpan></>;
    if (isYield) return <>Gift cards that <ColorizedSpan>grow</ColorizedSpan> in 3 steps</>;
    return <>Gift crypto in <ColorizedSpan>seconds</ColorizedSpan></>;
  };

  return (
    <>
      <Container>
        <InnerContainer>
          <Heading3Text
            style={{
              color: theme.text.title,
              width: '100%',
              textAlign: isMobile ? 'center' : 'left',
            }}
          >
            {getHeading()}
          </Heading3Text>
          <Image src='/landing-v2/anniversary-test.webp' />
        </InnerContainer>
        <SecondContainer>
          <div>
            <Line />
            {isPayments ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    1
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Create a link:</b>
                    </span>{' '}
                    Set the amount and currency you want to receive (USDC, BTC,
                    SOL).
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    2
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Share it anywhere:</b>
                    </span>{' '}
                    Your customer can pay with card, bank transfer, or crypto.
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    3
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>You receive crypto:</b>
                    </span>{' '}
                    Funds arrive instantly in your wallet — ready to spend
                    right away, no bank account needed.
                  </StyledParagraphLargeText>
                </div>
              </>
            ) : isYield ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    1
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Create a yield gift card:</b>
                    </span>{' '}
                    Set the amount. Its value grows while it sits.
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    2
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Send it:</b>
                    </span>{' '}
                    Share via link or email. No wallet needed to receive.
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    3
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Spend or grow:</b>
                    </span>{' '}
                    Use it at top brands or keep it and watch it grow.
                  </StyledParagraphLargeText>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    1
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Pick a gift:</b>
                    </span>{' '}
                    Crypto or stocks.
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    2
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Personalize it:</b>
                    </span>{' '}
                    Add a message and choose a design.
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    3
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>Claim effortlessly:</b>
                    </span>{' '}
                    One tap to claim. No wallet or crypto knowledge needed.
                  </StyledParagraphLargeText>
                </div>
              </>
            )}
            <Line />
          </div>
        </SecondContainer>
      </Container>
    </>
  );
};

export default HowItWorks;
